import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import logo from "../images/logo.svg";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
const Footer = () => {
  return (
    <motion.footer
      className="footer"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
      viewport={{ once: true }}
    >
      <Container>
        <Row className="footer-top">
          <Col md={8} className="footer-info">
          <Row>
            <Col md={4}>
            <motion.h5
              initial={{ opacity: 0, x: window.innerWidth < 768 ? 0 : -100 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
              viewport={{ once: false, amount: 0.3 }}
            >
              Contact
            </motion.h5>
              <motion.p
          initial={{ opacity: 0, x: 50 }} 
          whileInView={{ opacity: 1, x: 0 }} 
          transition={{ duration: 0.6, ease: "easeOut" }}
          viewport={{ once: false, amount: 0.3 }}
        >
          <strong>Mobile</strong><br />+61 481 829 998
        </motion.p>
        <motion.p
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
          viewport={{ once: false, amount: 0.3 }}
        >
          <strong>Email</strong><br />studio@edu360.com.au
        </motion.p>
            </Col>

            <Col md={4}>
              <motion.h5
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
                viewport={{ once: false, amount: 0.3 }}
              >
                Opening Hours
              </motion.h5>
              <motion.p
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
          viewport={{ once: false, amount: 0.3 }}
        >
          <strong>Mon – Fri</strong><br />9:00am - 5:00pm
        </motion.p>
        <motion.p
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, ease: "easeOut", delay: 0.3 }}
          viewport={{ once: false, amount: 0.3 }}
        >
          <strong>IT Support Plan Clients</strong><br />24/7, 7 days a week
        </motion.p>
            </Col>

            <Col md={4}>
              <motion.h5
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
                viewport={{ once: false, amount: 0.3 }}
              >
                Address
              </motion.h5>
              <motion.p
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, ease: "easeOut", delay: 0.4 }}
          viewport={{ once: false, amount: 0.3 }}
        >
          Halycon<br />St Kilda East<br />VIC 3183
        </motion.p>
            </Col>
          </Row>
          </Col>

          <Col md={4} className="footer-social text-end">
          <div className="social-icons">
            <motion.a
              href="https://www.facebook.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: [10, -10, 0] }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                viewport={{ once: false, amount: 0.3 }}
              >
                <FaFacebookF />
              </motion.div>
            </motion.a>

            <motion.a
              href="https://www.instagram.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: [10, -10, 0] }}
                transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
                viewport={{ once: false, amount: 0.3 }}
              >
                <FaInstagram />
              </motion.div>
            </motion.a>

            <motion.a
              href="https://www.linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: [10, -10, 0] }}
                transition={{ duration: 0.6, ease: "easeOut", delay: 0.4 }}
                viewport={{ once: false, amount: 0.3 }}
              >
                <FaLinkedinIn />
              </motion.div>
            </motion.a>
          </div>

          <div className="footer-logo">
            <motion.img
              src={logo}
              alt="Edu360 Logo"
              initial={{ opacity: 0, scale: 0.5 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              viewport={{ once: false, amount: 0.3 }}
            />
          </div>
          </Col>
        </Row>

        <Row className="justify-content-center footer-links nm">
      {["HOME", "WORK", "SERVICES", "REVIEWS", "ABOUT", "CONTACT"].map((item, index) => (
        <Col xs="auto" key={item}>
          <motion.a
            href="#"
            initial={{ opacity: 0, x: window.innerWidth < 768 ? 0 : -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, ease: "easeOut", delay: index * 0.1 }}
            viewport={{ once: false, amount: 0.3 }}
          >
            {item}
          </motion.a>
        </Col>
      ))}

      <Col md={6} className="text-md-end text-end d-none d-md-block">
        <motion.p
          className="footer-copyright"
          initial={{ opacity: 0, x: 100 }} 
          whileInView={{ opacity: 1, x: 0 }} 
          transition={{ duration: 0.6, ease: "easeOut", delay: 0.6 }} 
          viewport={{ once: false, amount: 0.3 }} 
        >
          edu360 © 2025, all rights reserved.
        </motion.p>
      </Col>
    </Row>

      
        <div className="footer-divider"></div>

      
        <Row className="footer-bottom">
          <Col md={12}>
          <motion.p
              className="footer-acknowledgment"
              initial={{ opacity: 0, y: -20 }}
              whileInView={{ opacity: 1, y: [0, -10, 10, 0] }}
              transition={{ duration: 1.2, ease: "easeInOut" }}
              viewport={{ once: false, amount: 0.3 }}
            >
              edu360 would like to acknowledge and pay respect to the Traditional Custodians of the lands and waterways of Australia. 
              We pay our respects to Elders past, present and emerging, for they hold the memories, the traditions, the culture, and 
              hopes of our nation. We acknowledge that Aboriginal and Torres Strait Islander people continue to live in spiritual 
              and sacred relationships with this country.
            </motion.p>
            {/* Show copyright below acknowledgment for small screens */}
            {/* <p className="footer-copyright d-md-none">
              edu360 © 2024, all rights reserved.
            </p> */}
            <motion.p
                  className="footer-copyright d-md-none"
                  initial={{ opacity: 0, x: 100 }} 
                  whileInView={{ opacity: 1, x: 0 }} 
                  transition={{ duration: 0.6, ease: "easeOut", delay: 0.6 }} 
                  viewport={{ once: false, amount: 0.3 }} 
                >
                  edu360 © 2025, all rights reserved.
                </motion.p>
          </Col>
        </Row>
      </Container>
    </motion.footer>
  );
};

export default Footer;
